import React, { Component } from 'react';

import queryString from 'query-string';
import firebase from 'firebase/app';
import Button from 'react-bootstrap/Button';

import './SignInButtons.css';


export async function saveSignInParam(collectionRef, userRef) {
  let userData = userRef.exists ? userRef.data() : null
  const query = queryString.parse(window.location.search)
  const storageItem = {}
  Object.keys(query)
    .filter((k) => k.startsWith('userparam.'))
    .forEach((k) => {
      storageItem[k.substring(10)] = query[k]
    })
  const useApp = query.ios === '1' || (navigator.userAgent || '').includes('Cloze Test App')
  if (useApp) {
    storageItem.useapp = 1
  }
  if (storageItem.length === 0) {
    return userData
  }
  if (userData === null) {
    userData = {}
  }
  let lastSignInParam = {}
  if (userData.signInParam !== undefined) {
    lastSignInParam = Object.assign(lastSignInParam, userData.signInParam)
  }
  userData.signInParam = Object.assign(lastSignInParam, storageItem)
  if (collectionRef) {
    await collectionRef.doc(userRef.id).set(userData)
  }
  return userData
}

export function createGoogleAuthProvider() {
  const provider = new firebase.auth.GoogleAuthProvider()
  provider.setCustomParameters({
    prompt: 'select_account',
  })
  return provider
}

export function onAuthStateChanged(auth, callback) {
  if (processLTICustomToken(auth, callback)) {
    return;
  }
  auth.onAuthStateChanged(user => {
    const onCTAuthStateChanged = window.onCTAuthStateChanged;
    if (user === null && onCTAuthStateChanged) {
      onCTAuthStateChanged(auth, callback);
      return;
    }
    callback(user);
  });
}

export function inLTIContext(user) {
  const url = new URL(window.location);
  const params = new URLSearchParams(url.search);
  const token = params.get('lti');
  if (!token) {
    return false;
  }
  return true;
}

function processLTICustomToken(auth, callback) {
  const url = new URL(window.location);
  const params = new URLSearchParams(url.search);
  const token = params.get('lti');
  if (!token) {
    return false;
  }
  auth.signInWithCustomToken(token)
    .then((userCredential) => {
      callback(userCredential.user);
    })
    .catch((error) => {
      console.error('Cannot sign in with custom token', error);
      callback(null, error);
    });
  return true;
}

export class SignInButtons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signningIn: false,
    };
  }

  googleSignIn() {
    const provider = createGoogleAuthProvider()
    this.signIn(provider)
  }

  appleSignIn() {
    const provider = new firebase.auth.OAuthProvider('apple.com')
    this.signIn(provider)
  }

  signIn(provider) {
    this.setState({
      signningIn: true,
    }, () => {
      if (!this.props.signIn) {
        return
      }
      this.props.signIn(provider)
    })
  }

  render() {
    const query = queryString.parse(window.location.search);
    const iosApp = query.ios === '1' || (navigator.userAgent || '').includes('Cloze Test App')

    return <div>
      <div className='DashboardLogin'>
        {this.props.description}Googleアカウント{iosApp && 'またはApple ID'}による認証が必要です。
        {iosApp &&
          <div className='PrivacyPolicy'>
            ログインボタンをクリックすることにより、<a href='/ios/tos.html' target='_blank'>Cloze Test iOSアプリ 利用規約</a>に同意したものとみなします。
          </div>}
        {this.props.option}
      </div>
      <div className='SignInButtons'>
        <div className='SignInButton'>
          <Button
            data-test-cloze-google-sign-in
            onClick={e => this.googleSignIn()}
            className='SignInWithGoogle'
            disabled={this.state.signningIn}
          >
            Googleアカウントでログイン
          </Button>
        </div>
        {iosApp && <div className='SignInButton'>
          <Button
            data-test-cloze-apple-sign-in
            onClick={e => this.appleSignIn()}
            className='SignInWithApple'
            disabled={this.state.signningIn}
          >
            <img alt='Apple Logo' src='/logo/apple.png' />
            Appleでサインイン
          </Button>
        </div>}
      </div>
      {this.state.signningIn && <div className='SignInProgress'>ログインしています...</div>}
      {!this.state.signningIn && iosApp &&
        <div className='AppQuestionnaire'>
          初回ログイン時にアンケートを実施させていただきます。このアンケートはアプリによる通知送信の目的にのみ利用します。
        </div>}
    </div>
  }
}
